var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isRouterAlive)?_c('div',{attrs:{"id":"app"}},[_c('Nav'),_c('router-view',{key:_vm.$route.fullPath}),_c('footer2')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }